import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Nav, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import { Facebook, GitHub, LinkedIn, Telegram } from '@mui/icons-material';
import CustomButton from '../Button/Button';
import './Header.css'

export const socialIcons = [
    {
        id: 1,
        name: <Facebook />,
        link: "https://www.facebook.com/iazadur/"
    },
    {
        id: 2,
        name: <LinkedIn />,
        link: "https://www.linkedin.com/in/iamazadur/"
    },
    {
        id: 3,
        name: <GitHub />,
        link: "https://github.com/iazadur"
    }
]



const Header = (props) => {
    const pathName = props?.location?.pathname;
    console.log(pathName);
    return (
        <Navbar expand="lg" sticky="top" className="header">
            {/* home navlink */}
            <Nav.Link as={NavLink} to="/" className="p-0 m-0">
                <Navbar.Brand className="header-home rounded-start"><HomeIcon></HomeIcon></Navbar.Brand>
            </Nav.Link>

            <Navbar.Toggle />

            <Navbar.Collapse >

                <Nav className="header-left">
                    <Nav.Link
                        as={NavLink}
                        to="/resume"
                        className={pathName === "/" ? "header-link-active" : "header-link"}>
                        Resume
                    </Nav.Link>

                    <Nav.Link
                        as={NavLink}
                        to="/protfolio"
                        className={pathName === "/protfolio" ? "header-link-active" : "header-link"}>
                        Protfolio
                    </Nav.Link>

                    <Nav.Link
                        as={NavLink}
                        to="/contact"
                        className={pathName === "/contact" ? "header-link-active" : "header-link"}>
                        contact
                    </Nav.Link>

                </Nav>
                <div className="header-right">
                    
                        <a href="https://www.facebook.com/iazadur/"  target="_blank" className="fw-bold" rel="noopener noreferrer"><Facebook className="socialIcon" /></a>
                        <a href="https://www.linkedin.com/in/iamazadur/" target="_blank" rel="noopener noreferrer"><LinkedIn /></a>
                        <a href="https://github.com/iazadur" target="_blank" rel="noopener noreferrer"><GitHub /></a>
                        
                    
                    <a style={{textDecoration:"none"}} href="https://drive.google.com/file/d/1-iD5aDhXCk0YaSnk7jrM945t4ktpLxWF/view?usp=sharing" target="_blank" rel="noopener noreferrer"><CustomButton text={'Hire Me'} icon={<Telegram />}></CustomButton></a>
                    
                </div>

            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;